import { CommonSettings } from '@starsoft/common/interfaces/common-settings';
import { SetSettingPayload, SettingsActions } from './props';

export function setSettings(settings: CommonSettings): SetSettingPayload {
  return {
    type: SettingsActions.SetSettings,
    payload: settings,
  };
}
